import { Component, ElementRef, Input, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-preview-geojson-leaflet-map',
  templateUrl: './preview-geojson-leaflet-map.html',
  styleUrls: ['./preview-geojson-leaflet-map.scss'],
})
export class PreviewGeojsonLeafletMapComponent implements OnInit {
  @Input() target: any = { geoJSON: '', area: 0 };

  map!: L.Map;
  dataLoading = true;
  latlonOverlay = '';
  geoJsonLayer: any;

  streetLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; OpenStreetMap contributors'
  });


  constructor(
    private dialogRef: MatDialogRef<PreviewGeojsonLeafletMapComponent>,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    this.initLeaflet();
    this.loadGeoJson();
  }

  initLeaflet() {
    const container = this.el.nativeElement.querySelector('#leafletContainer');

    this.map = L.map(container, {
      zoomControl: true,
      preferCanvas: true,
      fadeAnimation: true,
      zoomAnimation: true,
      markerZoomAnimation: true,
      layers: [this.streetLayer],
    }).setView([20, 78], 1);
    this.map.setMinZoom(1);
    this.map.setMaxZoom(18);

    (this.map as any).getPane('popupPane').style.zIndex = 5000;
    (this.map as any).getPane('tooltipPane').style.zIndex = 4900;

    this.map.on('mousemove', (e: any) => {
      this.latlonOverlay = `Lat: ${e.latlng.lat.toFixed(5)}, Lng: ${e.latlng.lng.toFixed(5)}`;
    });

    const baseMaps = {
      'OpenStreetMap': this.streetLayer,
    };

    const layerControl = L.control.layers(baseMaps, {}, { collapsed: true }).addTo(this.map);

    setTimeout(() => {
      const btn = L.DomUtil.create('div', 'custom-layer-btn leaflet-bar');
      btn.innerHTML = `<img src="assets/icons/layers.png" style="width:30px; padding:4px; cursor:pointer;">`;

      L.DomEvent.disableClickPropagation(btn);

      L.DomEvent.on(btn, 'click', () => {
        const lc = document.querySelector('.leaflet-control-layers') as HTMLElement;
        lc.classList.toggle('leaflet-control-layers-expanded');
      });

      const topRight = document.querySelector('.leaflet-top.leaflet-right') as HTMLElement;
      topRight.appendChild(btn);
    }, 300);

    setTimeout(() => this.map.invalidateSize(true), 500);
  }

  loadGeoJson() {
    const geoJsonUrl = '../../../assets/json/HydrosatTaskingRegions.geojson';

    fetch(geoJsonUrl)
      .then((response) => response.json())
      .then((data) => {
        this.geoJsonLayer = L.geoJSON(data, {
          coordsToLatLng: (coords) => L.latLng(coords[1], coords[0]),
          style: {
            color: 'maroon',
            weight: 1,
            fillColor: 'maroon',
            fillOpacity: 0.55,
          },
        }).addTo(this.map);

        this.map.flyToBounds(this.geoJsonLayer.getBounds(), {
          duration: 1.2,
          easeLinearity: 0.3
        });

        this.dataLoading = false;
      })
      .catch((err) => {
        console.error('Error loading GeoJSON:', err);
        this.dataLoading = false;
      });
  }

  onKeyPress(e: any, msg: string) {
    if (e.key === 'Enter') {
      this.onNoClick(msg);
    }
  }

  onNoClick(msg: any) {
    this.dialogRef.close('Done');
  }
}
